import React, { Suspense, lazy, useEffect, useState } from "react";
import { BrowserRouter, HashRouter, Switch, Redirect, Route as RouterRoute } from "react-router-dom";

import LoggedInLayout from "../layout";
import BackdropLoading from "../components/BackdropLoading";
import { AuthProvider, AuthContext } from "../context/Auth/AuthContext";
import { TicketsContextProvider } from "../context/Tickets/TicketsContext";
import { WhatsAppsProvider } from "../context/WhatsApp/WhatsAppsContext";
import { ToastProvider, ToastContainer } from "../components/Toast";
import Route from "./Route";
import "../pages/Barber/barberTheme.css";

const Dashboard = lazy(() => import("../pages/Dashboard/"));
const TicketResponsiveContainer = lazy(() => import("../pages/TicketResponsiveContainer"));
const Emails = lazy(() => import("../pages/Emails"));
const Login = lazy(() => import("../pages/Login/"));
const Connections = lazy(() => import("../pages/Connections/"));
const SettingsCustom = lazy(() => import("../pages/SettingsCustom/"));
const Financeiro = lazy(() => import("../pages/Financeiro/"));
const AsaasFinancial = lazy(() => import("../pages/AsaasFinancial"));
const ExpiredSubscription = lazy(() => import("../pages/ExpiredSubscription/"));
const Users = lazy(() => import("../pages/Users"));
const Equipes = lazy(() => import("../pages/Equipes"));
const UserProfile = lazy(() => import("../pages/UserProfile"));
const Contacts = lazy(() => import("../pages/Contacts/"));
const ContactImportPage = lazy(() => import("../pages/Contacts/import"));
const MomentsChat = lazy(() => import("../pages/Moments"));
const Queues = lazy(() => import("../pages/Queues/"));
const Tags = lazy(() => import("../pages/Tags/"));
const MessagesAPI = lazy(() => import("../pages/MessagesAPI/"));
const Helps = lazy(() => import("../pages/Helps/"));
const ContactLists = lazy(() => import("../pages/ContactLists/"));
const ContactListItems = lazy(() => import("../pages/ContactListItems/"));
const Companies = lazy(() => import("../pages/Companies/"));
const QuickMessages = lazy(() => import("../pages/QuickMessages/"));
const Schedules = lazy(() => import("../pages/Schedules"));
const Campaigns = lazy(() => import("../pages/Campaigns"));
const VoiceCampaigns = lazy(() => import("../pages/VoiceCampaigns"));
const GroupCampaigns = lazy(() => import("../pages/GroupCampaigns"));
const CampaignReport = lazy(() => import("../pages/CampaignReport"));
const EmailCampaigns = lazy(() => import("../pages/EmailCampaigns"));
const Annoucements = lazy(() => import("../pages/Annoucements"));
const Chat = lazy(() => import("../pages/Chat"));
const Prompts = lazy(() => import("../pages/Prompts"));
const AllConnections = lazy(() => import("../pages/AllConnections/"));
const Reports = lazy(() => import("../pages/Reports"));
const QueueIntegration = lazy(() => import("../pages/QueueIntegration"));
const Files = lazy(() => import("../pages/Files/"));
const ToDoList = lazy(() => import("../pages/ToDoList/"));
const DocumentSignatureModule = lazy(() => import("../pages/DocumentSignatureModule"));
const Workspace = lazy(() => import("../pages/Workspace"));
const Advoc360 = lazy(() => import("../pages/Advoc360"));
const Kanban = lazy(() => import("../pages/Kanban"));
const TagsKanban = lazy(() => import("../pages/TagsKanban"));
const AgendaCare = lazy(() => import("../pages/AgendaCare"));
const OdontoCare = lazy(() => import("../pages/OdontoCare"));
const PetCare = lazy(() => import("../pages/PetCare"));
const RotaVendas360 = lazy(() => import("../pages/RotaVendas360"));
const RotaVendasRouteForm = lazy(() => import("../pages/RotaVendas360/RouteForm"));
const RotaVendasMyDay = lazy(() => import("../pages/RotaVendas360/MyDay"));
const RotaVendasDeliveryTracking = lazy(() => import("../pages/RotaVendas360/DeliveryTracking"));
const KnowledgeBase = lazy(() => import("../pages/KnowledgeBase"));
const PdvPage = lazy(() => import("../pages/Pdv"));
const LojaOnline = lazy(() => import("../pages/LojaOnline"));
const LojaOnlinePublic = lazy(() => import("../pages/LojaOnlinePublic"));
const ComidaNaPorta = lazy(() => import("../pages/ComidaNaPorta"));
const WooCommerceDashboard = lazy(() => import("../pages/WooCommerceDashboard/index"));
const ComidaNaPortaPublic = lazy(() => import("../pages/ComidaNaPortaPublic"));
const ComidaNaPortaPublicHub = lazy(() => import("../pages/ComidaNaPortaPublicHub"));
const WebchatPortal = lazy(() => import("../pages/WebchatPortal"));
const ComidaNaPortaRiderPortal = lazy(() => import("../pages/ComidaNaPortaRiderPortal"));
const Motoqueiro = lazy(() => import("../pages/Motoqueiro"));
const AiAgents = lazy(() => import("../pages/AiAgents"));
const AiHelpRequests = lazy(() => import("../pages/AiHelpRequests"));
const AiSecretaria = lazy(() => import("../pages/AiSecretaria"));
const McpAgents = lazy(() => import("../pages/McpAgents"));
const CallcenterCentral = lazy(() => import("../pages/CallcenterCentral"));
const Callcenter = lazy(() => import("../pages/Callcenter"));
const ErpPhoneSignature = lazy(() => import("../pages/ErpPhoneSignature"));
const ErpPhoneDashboard = lazy(() => import("../pages/ErpPhoneDashboard"));
const ErpPhoneDeviceProfile = lazy(() => import("../pages/ErpPhoneDeviceProfile"));
const Voip = lazy(() => import("../pages/Voip"));
const LegalDocument = lazy(() => import("../pages/LegalDocument"));
const WalletSector = lazy(() => import("../pages/WalletSector"));
const WalletManagement = lazy(() => import("../pages/WalletManagement"));
const SupportTickets = lazy(() => import("../pages/SupportTickets"));
const MetaAdsAnalytics = lazy(() => import("../pages/MetaAdsAnalytics"));
const TemplateAnalyticsWhats = lazy(() => import("../pages/TemplateAnalyticsWhats"));
const WhatsAppTemplates = lazy(() => import("../pages/WhatsAppTemplates"));
const EvolutionInteractives = lazy(() => import("../pages/EvolutionInteractives"));
const InternalNewsPortal = lazy(() => import("../pages/InternalNewsPortal"));
const BarberDashboard = lazy(() => import("../pages/Barber/Dashboard"));
const BarberServices = lazy(() => import("../pages/Barber/Services"));
const BarberClients = lazy(() => import("../pages/Barber/Clients"));
const BarberSchedules = lazy(() => import("../pages/Barber/Schedules"));
const BarberCommissions = lazy(() => import("../pages/Barber/Commissions"));
const BarberSales = lazy(() => import("../pages/Barber/Sales"));
const BarberEmployees = lazy(() => import("../pages/Barber/Employees"));
const BarberReports = lazy(() => import("../pages/Barber/Reports"));
const BarberSettings = lazy(() => import("../pages/Barber/Settings"));
const BarberCredits = lazy(() => import("../pages/Barber/Credits"));
const BarberProducts = lazy(() => import("../pages/Barber/Products"));
const BarberStock = lazy(() => import("../pages/Barber/Stock"));
const BarberSuppliers = lazy(() => import("../pages/Barber/Suppliers"));
const BarberPurchases = lazy(() => import("../pages/Barber/Purchases"));
const BarberPayables = lazy(() => import("../pages/Barber/Payables"));
const BarberReceivables = lazy(() => import("../pages/Barber/Receivables"));
const BarberReturnsBirthdays = lazy(() => import("../pages/Barber/ReturnsBirthdays"));
const BarberRoles = lazy(() => import("../pages/Barber/Roles"));
const BarberAccess = lazy(() => import("../pages/Barber/Access"));
const BarberMyAgenda = lazy(() => import("../pages/Barber/MyAgenda"));
const BarberMyServices = lazy(() => import("../pages/Barber/MyServices"));
const BarberMyCommissions = lazy(() => import("../pages/Barber/MyCommissions"));
const GroupManagement = lazy(() => import("../pages/GroupManagement"));
// EduCare Module
const EduCare = lazy(() => import("../pages/EduCare"));
// Serviços Module
const Services = lazy(() => import("../pages/Services"));
const ServiceProfessionals = lazy(() => import("../pages/ServiceProfessionals"));
const ServiceList = lazy(() => import("../pages/ServiceList"));
const ServiceAppointments = lazy(() => import("../pages/ServiceAppointments"));
const ServiceFinancial = lazy(() => import("../pages/ServiceFinancial"));
const ServiceMessaging = lazy(() => import("../pages/ServiceMessaging"));
const ServiceQueues = lazy(() => import("../pages/ServiceQueues"));
const SocialPosts = lazy(() => import("../pages/SocialPosts"));
const SocialTriggers = lazy(() => import("../pages/SocialTriggers"));
const MeetingRooms = lazy(() => import("../pages/MeetingRooms"));
const MeetingGuest = lazy(() => import("../pages/MeetingGuest"));
const FlowProcess = lazy(() => import("../pages/FlowProcess"));
const FlowProcessBuilder = lazy(() => import("../pages/FlowProcess/Builder"));
const BancarioCartoes = lazy(() => import("../pages/BancarioCartoes"));
const FlowProcessReports = lazy(() => import("../pages/FlowProcessReports"));
const FlowProcessTemplates = lazy(() => import("../pages/FlowProcess/Templates"));
const FlowProcessCategories = lazy(() => import("../pages/FlowProcess/Categories"));

const Routes = () => {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(false);
  }, []);

  if (loading) {
    return null;
  }

  // O sistema legado continua no HashRouter; o Portal é público e precisa de
  // uma URL compartilhável sem '#', como /webchat/minha-empresa.
  const AppRouter = window.location.pathname.startsWith("/webchat/") || window.location.pathname.startsWith("/loja/")
    ? BrowserRouter
    : HashRouter;

  return (
    <AppRouter>
      <ToastProvider>
        <AuthProvider>
          <TicketsContextProvider>
            <Suspense fallback={<BackdropLoading />}>
              <Switch>
              <RouterRoute exact path="/termos" component={LegalDocument} />
              <RouterRoute exact path="/politica-de-privacidade" component={LegalDocument} />
              <RouterRoute exact path="/cardapio" component={ComidaNaPortaPublicHub} />
              <RouterRoute exact path="/webchat/:slug" component={WebchatPortal} />
              <RouterRoute exact path="/loja/:slug" component={LojaOnlinePublic} />
              <RouterRoute exact path="/cardapio/:companyToken" component={ComidaNaPortaPublic} />
              <RouterRoute exact path="/entregador/:companyToken" component={ComidaNaPortaRiderPortal} />
              <RouterRoute exact path="/meeting/:token" component={MeetingGuest} />
              <RouterRoute exact path="/rastrear/:token" component={RotaVendasDeliveryTracking} />
              <Route exact path="/login" component={Login} />
              <Route exact path="/erpfone/sign/:token" component={ErpPhoneSignature} />
              <Route
                exact
                path="/expired-subscription"
                component={ExpiredSubscription}
              />
              <Route
                exact
                path="/signup"
                component={Login}
              />
              <AuthContext.Consumer>
                {({ isAuth, loading: authLoading }) =>
                  authLoading ? (
                    <BackdropLoading />
                  ) : isAuth ? (
                    <WhatsAppsProvider>
                      <LoggedInLayout>
                        <Route
                          exact
                          path="/financeiro"
                          component={Financeiro}
                          isPrivate
                        />
                        <Route
                          exact
                          path="/financeiro-aberto"
                          component={Financeiro}
                          isPrivate
                        />
                        <Route
                          exact
                          path="/asaas-financial"
                          component={AsaasFinancial}
                          isPrivate
                        />

                        <Route
                          exact
                          path="/companies"
                          component={Companies}
                          isPrivate
                        />
                        <Route exact path="/" component={Dashboard} isPrivate />
                        <Route exact path="/motoqueiro" component={Motoqueiro} isPrivate />
                        <Route
                          exact
                          path="/tickets/:ticketId?"
                          component={TicketResponsiveContainer}
                          isPrivate
                        />
                        <Route
                          exact
                          path="/emails"
                          component={Emails}
                          isPrivate
                        />
                        <Route
                          exact
                          path="/connections"
                          component={Connections}
                          isPrivate
                        />
                        <Route
                          exact
                          path="/quick-messages"
                          component={QuickMessages}
                          isPrivate
                        />
                        <Route
                          exact
                          path="/todolist"
                          component={ToDoList}
                          isPrivate
                        />
                        <Route
                          exact
                          path="/consulta-processo"
                          component={Workspace}
                          isPrivate
                        />
                        <Route
                          exact
                          path="/advoc360"
                          component={Advoc360}
                          isPrivate
                        />
                        <Route
                          exact
                          path="/document-signature"
                          component={DocumentSignatureModule}
                          isPrivate
                        />
                        <Route
                          exact
                          path="/support-tickets/:ticketId?"
                          component={SupportTickets}
                          isPrivate
                        />
                        <Route
                          exact
                          path="/my-wallet"
                          component={WalletSector}
                          isPrivate
                        />
                        <Route
                          exact
                          path="/wallet-sector"
                          component={WalletSector}
                          isPrivate
                        />
                        <Route
                          exact
                          path="/wallet-management"
                          component={WalletManagement}
                          isPrivate
                        />
                        <Route
                          exact
                          path="/schedules"
                          component={Schedules}
                          isPrivate
                        />
                        <Route
                          exact
                          path="/social-triggers"
                          component={SocialTriggers}
                          isPrivate
                        />
                        <Route
                          exact
                          path="/social-posts"
                          component={SocialPosts}
                          isPrivate
                        />
                        <Route
                          exact
                          path="/meeting-rooms"
                          component={MeetingRooms}
                          isPrivate
                        />
                        <Route exact path="/tags" component={Tags} isPrivate />
                        <Route exact path="/flow-process" component={FlowProcess} isPrivate />
                        <Route exact path="/flow-process/templates" component={FlowProcessTemplates} isPrivate />
                        <Route exact path="/flow-process/categories" component={FlowProcessCategories} isPrivate />
                        <Route exact path="/flow-process/builder/:templateId" component={FlowProcessBuilder} isPrivate />
                        <Route exact path="/flow-process/reports" component={FlowProcessReports} isPrivate />
                        <Route exact path="/flow-process/:instanceId" component={FlowProcess} isPrivate />
                        <Route exact path="/pdv" component={PdvPage} isPrivate />
                        <Route exact path="/loja-online" component={LojaOnline} isPrivate />
                        <Route exact path="/comida-na-porta" component={ComidaNaPorta} isPrivate />
                        <Route exact path="/woocommerce" component={WooCommerceDashboard} isPrivate />
                        <Route exact path="/bancario-cartoes" component={BancarioCartoes} isPrivate />
                        <Route path="/erpfone" component={ErpPhoneDashboard} isPrivate />
                        <Route
                          exact
                          path="/erpfone/aparelhos/:deviceId"
                          component={ErpPhoneDeviceProfile}
                          isPrivate
                        />
                        <Route exact path="/voip" component={Voip} isPrivate />
                        <Route
                          exact
                          path="/agendacare"
                          component={AgendaCare}
                          isPrivate
                        />
                        <Route
                          exact
                          path="/odontocare"
                          component={OdontoCare}
                          isPrivate
                        />
                        <Route
                          exact
                          path="/petcare"
                          component={PetCare}
                          isPrivate
                        />
                        <Route
                          exact
                          path="/rotsa_360/nova"
                          component={RotaVendasRouteForm}
                          isPrivate
                        />
                        <Route
                          exact
                          path="/rotsa_360/meu-dia"
                          component={RotaVendasMyDay}
                          isPrivate
                        />
                        <Route
                          exact
                          path="/rotsa_360/:routeId"
                          component={RotaVendasRouteForm}
                          isPrivate
                        />
                        <Route
                          exact
                          path="/rotsa_360"
                          component={RotaVendas360}
                          isPrivate
                        />
                        <Route
                          exact
                          path="/barber"
                          component={BarberDashboard}
                          isPrivate
                        />
                        <Route
                          exact
                          path="/barber/services"
                          component={BarberServices}
                          isPrivate
                        />
                        <Route
                          exact
                          path="/barber/clients"
                          component={BarberClients}
                          isPrivate
                        />
                        <Route
                          exact
                          path="/barber/schedules"
                          component={BarberSchedules}
                          isPrivate
                        />
                        <Route
                          exact
                          path="/barber/commissions"
                          component={BarberCommissions}
                          isPrivate
                        />
                        <Route
                          exact
                          path="/barber/sales"
                          component={BarberSales}
                          isPrivate
                        />
                        <Route
                          exact
                          path="/barber/employees"
                          component={BarberEmployees}
                          isPrivate
                        />
                        <Route
                          exact
                          path="/barber/reports"
                          component={BarberReports}
                          isPrivate
                        />
                        <Route
                          exact
                          path="/barber/settings"
                          component={BarberSettings}
                          isPrivate
                        />
                        <Route
                          exact
                          path="/barber/credits"
                          component={BarberCredits}
                          isPrivate
                        />
                        <Route exact path="/barber/products" component={BarberProducts} isPrivate />
                        <Route exact path="/barber/stock" component={BarberStock} isPrivate />
                        <Route exact path="/barber/suppliers" component={BarberSuppliers} isPrivate />
                        <Route exact path="/barber/purchases" component={BarberPurchases} isPrivate />
                        <Route exact path="/barber/payables" component={BarberPayables} isPrivate />
                        <Route exact path="/barber/receivables" component={BarberReceivables} isPrivate />
                        <Route exact path="/barber/returns-birthdays" component={BarberReturnsBirthdays} isPrivate />
                        <Route exact path="/barber/roles" component={BarberRoles} isPrivate />
                        <Route exact path="/barber/access" component={BarberAccess} isPrivate />
                        <Route exact path="/barber/my-agenda" component={BarberMyAgenda} isPrivate />
                        <Route exact path="/barber/my-services" component={BarberMyServices} isPrivate />
                        <Route exact path="/barber/my-commissions" component={BarberMyCommissions} isPrivate />
                        <Route
                          exact
                          path="/contacts"
                          component={Contacts}
                          isPrivate
                        />
                        <Route
                          exact
                          path="/contacts/import"
                          component={ContactImportPage}
                          isPrivate
                        />
                        <Route
                          exact
                          path="/helps"
                          component={Helps}
                          isPrivate
                        />
                        <Route
                          exact
                          path="/users"
                          component={Users}
                          isPrivate
                        />
                        <Route
                          exact
                          path="/users/:userId/profile"
                          component={UserProfile}
                          isPrivate
                        />
                        <Route
                          exact
                          path="/messages-api"
                          component={MessagesAPI}
                          isPrivate
                        />
                        <Route
                          exact
                          path="/settings"
                          component={SettingsCustom}
                          isPrivate
                        />
                        <Route
                          exact
                          path="/evolution-interactives"
                          component={EvolutionInteractives}
                          isPrivate
                        />
                        <Route
                          exact
                          path="/queues"
                          component={Queues}
                          isPrivate
                        />
                        <Route
                          exact
                          path="/equipes"
                          component={Equipes}
                          isPrivate
                        />
                        <Route
                          exact
                          path="/group-management"
                          component={GroupManagement}
                          isPrivate
                        />
                        <Route
                          exact
                          path="/reports"
                          component={Reports}
                          isPrivate
                        />
                        <Route
                          exact
                          path="/analytics-template-whats"
                          component={TemplateAnalyticsWhats}
                          isPrivate
                        />
                        <Route
                          exact
                          path="/whatsapp-templates"
                          component={WhatsAppTemplates}
                          isPrivate
                        />
                        <Route
                          exact
                          path="/meta-ads"
                          component={MetaAdsAnalytics}
                          isPrivate
                        />
                        <Route
                          exact
                          path="/meta-ads/:section"
                          component={MetaAdsAnalytics}
                          isPrivate
                        />
                        <Route
                          exact
                          path="/queue-integration"
                          component={QueueIntegration}
                          isPrivate
                        />
                        <Route
                          exact
                          path="/announcements"
                          component={Annoucements}
                          isPrivate
                        />
                        <Route
                          exact
                          path="/knowledge-base"
                          component={KnowledgeBase}
                          isPrivate
                        />
                        <Route
                          exact
                          path="/portal-interno"
                          component={InternalNewsPortal}
                          isPrivate
                        />
                        <Route
                          exact
                          path="/chats/:id?"
                          component={Chat}
                          isPrivate
                        />
                        <Route
                          exact
                          path="/files"
                          component={Files}
                          isPrivate
                        />
                        <Route
                          exact
                          path="/moments"
                          component={MomentsChat}
                          isPrivate
                        />
                        <Route
                          exact
                          path={["/kanban", "/Kanban"]}
                          component={Kanban}
                          isPrivate
                        />
                        <Route
                          exact
                          path={["/tagsKanban", "/TagsKanban", "/tagskanban"]}
                          component={TagsKanban}
                          isPrivate
                        />
                        <Route
                          exact
                          path="/prompts"
                          component={Prompts}
                          isPrivate
                        />
                        <Route
                          exact
                          path="/ai-agents"
                          component={AiAgents}
                          isPrivate
                        />
                        <Route
                          exact
                          path="/mcp-agents"
                          component={McpAgents}
                          isPrivate
                        />
                        <Route
                          exact
                          path="/ai-help-requests"
                          component={AiHelpRequests}
                          isPrivate
                        />
                        <Route
                          exact
                          path="/ai-secretaria"
                          component={AiSecretaria}
                          isPrivate
                        />
                        <Route
                          exact
                          path="/ai-executive-office"
                          component={AiSecretaria}
                          isPrivate
                        />
                        <Route
                          exact
                          path="/ai-executive-office/agents"
                          component={AiSecretaria}
                          isPrivate
                        />
                        <Route
                          exact
                          path="/ai-executive-office/agents/:id/dashboard"
                          component={AiSecretaria}
                          isPrivate
                        />
                        <Route
                          exact
                          path="/ai-executive-office/agents/:id/inbox"
                          component={AiSecretaria}
                          isPrivate
                        />
                        <Route
                          exact
                          path="/ai-executive-office/agents/:id/missions"
                          component={AiSecretaria}
                          isPrivate
                        />
                        <Route
                          exact
                          path="/ai-executive-office/missions/:id"
                          component={AiSecretaria}
                          isPrivate
                        />
                        <Route
                          exact
                          path="/ai-executive-office/skills"
                          component={AiSecretaria}
                          isPrivate
                        />
                        <Route
                          exact
                          path="/ai-executive-office/tools"
                          component={AiSecretaria}
                          isPrivate
                        />
                        <Route
                          exact
                          path="/ai-executive-office/marketplace"
                          component={AiSecretaria}
                          isPrivate
                        />
                        <Route
                          exact
                          path="/ai-executive-office/audit"
                          component={AiSecretaria}
                          isPrivate
                        />
                        <Route
                          exact
                          path="/callcenter-central"
                          component={CallcenterCentral}
                          isPrivate
                        />
                        <Route
                          exact
                          path="/callcenter"
                          component={Callcenter}
                          isPrivate
                        />
                        <Route
                          exact
                          path="/allConnections"
                          component={AllConnections}
                          isPrivate
                        />
                        {/* EduCare */}
                        <Route exact path="/educare" component={EduCare} isPrivate />
                        {/* Serviços */}
                        <Route exact path="/services" component={Services} isPrivate />
                        <Route exact path="/service-professionals" component={ServiceProfessionals} isPrivate />
                        <Route exact path="/service-list" component={ServiceList} isPrivate />
                        <Route exact path="/service-appointments" component={ServiceAppointments} isPrivate />
                        <Route exact path="/service-financial" component={ServiceFinancial} isPrivate />
                        <Route exact path="/service-messaging" component={ServiceMessaging} isPrivate />
                        <Route exact path="/service-queues" component={ServiceQueues} isPrivate />
                            <Route
                              exact
                              path="/contact-lists"
                              component={ContactLists}
                              isPrivate
                            />
                            <Route
                              exact
                              path="/contact-lists/:contactListId/contacts"
                              component={ContactListItems}
                              isPrivate
                            />
                            <Route
                              exact
                              path="/campaigns"
                              component={Campaigns}
                              isPrivate
                            />
                            <Route
                              exact
                              path="/voice-campaigns"
                              component={VoiceCampaigns}
                              isPrivate
                            />
                            <Route
                              exact
                              path="/group-campaigns"
                              component={GroupCampaigns}
                              isPrivate
                            />
                            <Route
                              exact
                              path="/email-campaigns"
                              component={EmailCampaigns}
                              isPrivate
                            />
                            <Route
                              exact
                              path="/campaign/:campaignId/report"
                              component={CampaignReport}
                              isPrivate
                            />
                      </LoggedInLayout>
                    </WhatsAppsProvider>
                  ) : (
                    <Redirect to="/login" />
                  )
                }
              </AuthContext.Consumer>
              </Switch>
            </Suspense>
            <ToastContainer />
          </TicketsContextProvider>
        </AuthProvider>
      </ToastProvider>
    </AppRouter>
  );
};

export default Routes;
